export default __webpack_public_path__ + "static/media/peercoin-main-small.5d963912.png";